import React, { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faSignOutAlt,
    faEdit,
    faArrowLeft,
    faXmark 
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { clearUserFromServiceWorker } from '../utils/serviceWorkerUtils';
import ArrowLeft from './images/ArrowLeft.png';

function ProfileAccount() {
    const navigate = useNavigate();
    const [userData, setUserData] = useState({});
    const [vendorData, setVendorData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [walletBalance, setWalletBalance] = useState(0);
    const [editingProfile, setEditingProfile] = useState(false);
    const [editingContact, setEditingContact] = useState(false);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [profileForm, setProfileForm] = useState({
        customer_name: '',
        mobile_number: ''
    });
    const [contactForm, setContactForm] = useState({
        company_name: '',
        type_of_firm: '',
        gstin: '',
        pan: '',
        association: ''
    });

    const [showImageModal, setShowImageModal] = useState(false);
const [selectedImage, setSelectedImage] = useState('');
const [hasImage, setHasImage] = useState(false); // Track if an image exists


    useEffect(() => {
        loadUserData();
    }, []);

    useEffect(() => {
        if (userData.id) {
            getVendorDetails(userData.id);
        }
    }, [userData]);

    useEffect(() => {
        if (vendorData) {
            setProfileForm({
                customer_name: vendorData.Vendor[0].name || '',
                mobile_number: vendorData.Vendor[0].mobile_number || ''
            });
            setContactForm({
                company_name: vendorData.Vendor[0].company_name || '',
                type_of_firm: vendorData.Vendor[0].type_of_firm || '',
                gstin: vendorData.Vendor[0].gstin || '',
                pan: vendorData.Vendor[0].pan || '',
                association: vendorData.Vendor[0].association || ''
            });
        }
    }, [vendorData]);

    const loadUserData = () => {
        try {
            const storedData = localStorage.getItem('vendorData');
            if (storedData) {
                const parsedData = JSON.parse(storedData);
                setUserData(parsedData);
            } else {
                const sessionData = sessionStorage.getItem('vendorData');
                if (sessionData) {
                    const parsedData = JSON.parse(sessionData);
                    setUserData(parsedData);
                }
            }
        } catch (error) {
            console.error("Error loading user data:", error);
            setError("Failed to load user data");
        } finally {
            setLoading(false);
        }
    };

    const getVendorDetails = async (vendorid) => {
        const token = userData?.token || sessionStorage.getItem('token');
        
        try {
            const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}vendor/get-vendor-and-contacts?vendor_id=${vendorid}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-token': token
                }
            });
            
            const result = await response.json();
            console.log("Vendor Details:", result);
            
            if (result.success) {
                setVendorData(result.data);
                console.log("Vendor Details:", result.data);
            } else {
                console.error('Failed to fetch vendor:', result.message);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    // Update vendor and contacts API call
    const updateVendorAndContacts = async (updatedData) => {
        const token = userData?.token || sessionStorage.getItem('token');
        
        try {
            setUpdateLoading(true);
            
            const formData = new FormData();
            
            // Add vendor data to FormData
            formData.append('_id', vendorData.Vendor[0]._id);
            formData.append('name', updatedData.name);
            formData.append('mobile_number', updatedData.mobile_number);
            formData.append('company_name', updatedData.company_name);
            formData.append('gstin', updatedData.gstin);
            formData.append('pan', updatedData.pan);
                      
            // Add contacts data
            const contactsData = vendorData.contacts || [];
            formData.append('vendorContacts', JSON.stringify(contactsData));

            const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}vendor/update-vendor-and-contacts`, {
                method: 'PUT',
                headers: {
                    'x-token': token
                },
                body: formData
            });
            
            const result = await response.json();
            
            if (result.success) {
                // Update local vendor data
                setVendorData(prevData => ({
                    ...prevData,
                    Vendor: [{ ...prevData.Vendor[0], ...updatedData }]
                }));
                
                // Update local storage if needed
                const storedData = localStorage.getItem('vendorData');
                if (storedData) {
                    const parsedData = JSON.parse(storedData);
                    const updatedStoredData = {
                        ...parsedData,
                        name: updatedData.name,
                        mobile_number: updatedData.mobile_number,
                        company_name: updatedData.company_name
                    };
                    localStorage.setItem('vendorData', JSON.stringify(updatedStoredData));
                }
                
                return { success: true, message: 'Profile updated successfully' };
            } else {
                throw new Error(result.message || 'Failed to update profile');
            }
        } catch (error) {
            console.error('Error updating vendor:', error);
            return { success: false, message: error.message || 'Failed to update profile' };
        } finally {
            setUpdateLoading(false);
        }
    };

    const handleProfileSave = async () => {
        try {
            const updatedData = {
                name: profileForm.customer_name,
                mobile_number: profileForm.mobile_number,
                company_name: vendorData.Vendor[0].company_name,
                gstin: vendorData.Vendor[0].gstin,
                pan: vendorData.Vendor[0].pan
            };

            const result = await updateVendorAndContacts(updatedData);
            
            if (result.success) {
                setEditingProfile(false);
                // Show success message (you can add a toast notification here)
                console.log('Profile updated successfully');
            } else {
                // Show error message
                setError(result.message);
                console.error('Failed to update profile:', result.message);
            }
        } catch (error) {
            console.error('Error saving profile:', error);
            setError('Failed to save profile changes');
        }
    };

    const handleContactSave = async () => {
        try {
            const updatedData = {
                name: vendorData.Vendor[0].name,
                mobile_number: vendorData.Vendor[0].mobile_number,
                company_name: contactForm.company_name,
                gstin: contactForm.gstin,
                pan: contactForm.pan
            };

            const result = await updateVendorAndContacts(updatedData);
            
            if (result.success) {
                setEditingContact(false);
                // Show success message
                console.log('Contact information updated successfully');
            } else {
                // Show error message
                setError(result.message);
                console.error('Failed to update contact information:', result.message);
            }
        } catch (error) {
            console.error('Error saving contact information:', error);
            setError('Failed to save contact information');
        }
    };

    const handleLogout = () => {
        sessionStorage.clear();
        localStorage.clear();
        clearUserFromServiceWorker();
        navigate('/supplier');
    };

    const getInitials = (name) => {
        if (!name) return 'U';
        return name.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2);
    };

    if (loading) {
        return (
            <div className="flex flex-col w-full min-h-screen bg-gray-50">
                <div className="flex justify-center items-center h-screen">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col w-full min-h-screen bg-gray-50">
            {/* Header */}
           <div className="bg-white h-14 px-1 flex items-center sticky top-0 left-0 right-0 shadow-md z-50">
  
  <button onClick={() => window.history.back()} className=" active:scale-90">
    <img 
      src={ArrowLeft} 
      alt="Back" 
      className="w-12 h-8 object-contain"
    />
  </button>

  <h1 className="text-lg font-semibold text-gray-800">
     Profile
  </h1>

</div>


            {/* Error Message */}
            {error && (
                <div className="mx-4 mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
                    {error}
                </div>
            )}

            {/* User Profile Card */}
          <div className="mx-4 mt-4 bg-white rounded-lg p-4 shadow-sm">
    <div className="flex items-center justify-between mb-3">
        <div className="flex items-center">

            {/* FIXED IMAGE CONTAINER */}
         <div className="w-12 h-12 rounded-full bg-gray-200 border border-gray-200 overflow-hidden mr-3">
    {vendorData?.Vendor?.[0]?.image ? (
        <img
            src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${vendorData.Vendor[0].image}`}
            alt="Vendor"
            className="w-full h-full object-cover rounded-full"
            onClick={() => {
                setSelectedImage(`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${vendorData.Vendor[0].image}`);
                setHasImage(true);
                setShowImageModal(true);
            }}
            onError={(e) => (e.target.style.display = "none")}
        />
    ) : (
        <span 
            className="text-[#1A73E7] font-bold text-lg cursor-pointer flex items-center justify-center w-full h-full"
            onClick={() => {
                setSelectedImage('');
                setHasImage(false);
                setShowImageModal(true);
            }}
        >
            {getInitials(vendorData?.Vendor[0]?.name || userData?.customer_name)}
        </span>
    )}
</div>


            {/* VENDOR DETAILS */}
            <div>
                <h2 className="text-lg font-semibold text-[#000000]">
                    {vendorData?.Vendor[0].name || userData?.customer_name || 'User Name'}
                </h2>
                <p className="text-gray-500 text-sm">
                    {vendorData?.Vendor[0].mobile_number || userData?.mobile || 'Mobile number'}
                </p>
            </div>

        </div>
    </div>
</div>


            {/* Language Section */}
            <div className="mx-4 mt-4 bg-white rounded-lg p-4 shadow-sm">
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center mr-3">
                            <span className="text-gray-600 font-medium text-sm">A</span>
                        </div>
                        <span className="text-gray-900">Language (English)</span>
                    </div>
                    <button className="text-red-500 text-sm font-medium">
                        Change
                    </button>
                </div>
            </div>

            {/* Your Profile Section */}
            <div className="mx-4 mt-4 bg-white rounded-lg p-4 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-sm font-semibold text-[#000000]">Personal Information</h3>
                    {!editingProfile && (
                        <button 
                            onClick={() => setEditingProfile(true)}
                            className="text-red-500 text-sm font-medium flex items-center"
                            disabled={updateLoading}
                        >
                            <FontAwesomeIcon icon={faEdit} className="mr-1" />
                        </button>
                    )}
                </div>

                <div className="space-y-4">
                    {/* Name Field */}
                    <div>
                        <label className="block text-xs text-gray-500 mb-2">Name</label>
                        {editingProfile ? (
                            <input
                                type="text"
                                value={profileForm.customer_name}
                                onChange={(e) => setProfileForm({...profileForm, customer_name: e.target.value})}
                                className="w-full p-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-gray-300"
                                placeholder="Enter your name"
                                disabled={updateLoading}
                            />
                        ) : (
                            <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md">
                                <p className="text-gray-500 text-sm">{vendorData?.Vendor[0].name || 'Not provided'}</p>
                            </div>
                        )}
                    </div>

                    {/* Mobile Number Field */}
                                     {/* Mobile Number Field */}
                    <div>
                        <div className="flex items-center justify-between mb-2">
                            <label className="block text-xs text-gray-500">Mobile Number</label>
                        </div>
                        {editingProfile ? (
                            <input
                                type="text"
                                value={profileForm.mobile_number}
                                onChange={(e) => setProfileForm({...profileForm, mobile_number: e.target.value})}
                                className="w-full p-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-gray-300"
                                placeholder="Enter mobile number"
                                disabled={updateLoading}
                            />
                        ) : (
                            <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md">
                                <p className="text-gray-900 text-sm">{vendorData?.Vendor[0].mobile_number || 'Not provided'}</p>
                            </div>
                        )}
                    </div>

                    {editingProfile && (
                        <div className="flex justify-start pt-2">
                            <button 
                                onClick={handleProfileSave}
                                className="bg-red-500 text-white px-6 py-2 rounded-md text-sm font-medium mr-3"
                                disabled={updateLoading}
                            >
                                {updateLoading ? 'Saving...' : 'Save'}
                            </button>
                            <button 
                                onClick={() => {
                                    setEditingProfile(false);
                                    setError(null);
                                    // Reset form to original values
                                    setProfileForm({
                                        customer_name: vendorData?.Vendor[0].name || '',
                                        mobile_number: vendorData?.Vendor[0].mobile_number || ''
                                    });
                                }}
                                className="bg-gray-300 text-gray-700 px-6 py-2 rounded-md text-sm font-medium"
                                disabled={updateLoading}
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Contact Information Section */}
            <div className="mx-4 mt-4 bg-white rounded-lg p-4 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-sm font-semibold text-[#000000]">Contact Information</h3>
                    {!editingContact && (
                        <button 
                            onClick={() => setEditingContact(true)}
                            className="text-red-500 text-sm font-medium flex items-center"
                            disabled={updateLoading}
                        >
                            <FontAwesomeIcon icon={faEdit} className="mr-1" />
                        </button>
                    )}
                </div>

                <div className="space-y-4">
                    {/* Company Name */}
                    <div>
                        <label className="block text-xs text-gray-500 mb-2">Company Name</label>
                        {editingContact ? (
                            <input
                                type="text"
                                value={contactForm.company_name}
                                onChange={(e) => setContactForm({...contactForm, company_name: e.target.value})}
                                className="w-full p-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-gray-300"
                                placeholder="Enter company name"
                                disabled={updateLoading}
                            />
                        ) : (
                            <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md">
                                <p className="text-gray-900 text-sm">{vendorData?.Vendor[0].company_name || 'Not provided'}</p>
                            </div>
                        )}
                    </div>

                {/* GST */}
<div>
  <label className="block text-xs text-gray-500 mb-2">GST Number</label>
  {editingContact ? (
    <input
      type="text"
      value={contactForm.gstin}
      onChange={(e) => {
        const gst = e.target.value;

        // Auto extract PAN from GST
        const autoPan = gst.length >= 12 ? gst.substring(2, 12).toUpperCase() : '';

        setContactForm({
          ...contactForm,
          gstin: gst.toUpperCase(),
          pan: autoPan
        });
      }}
      className="w-full p-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-gray-300"
      placeholder="Enter GST number"
      disabled={updateLoading}
    />
  ) : (
    <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md">
      <p className="text-gray-900 text-sm">{vendorData?.Vendor[0].gstin || 'Not provided'}</p>
    </div>
  )}
</div>

{/* PAN (auto-filled, not editable) */}
<div>
  <label className="block text-xs text-gray-500 mb-2">PAN Number</label>
  {editingContact ? (
    <input
      type="text"
      value={contactForm.pan}
      className="w-full p-3 border border-gray-300 rounded-md text-sm bg-gray-100"
      disabled
    />
  ) : (
    <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md">
      <p className="text-gray-900 text-sm">{vendorData?.Vendor[0].pan || 'Not provided'}</p>
    </div>
  )}
</div>


                    {editingContact && (
                        <div className="flex justify-start pt-2">
                            <button 
                                onClick={handleContactSave}
                                className="bg-red-500 text-white px-6 py-2 rounded-md text-sm font-medium mr-3"
                                disabled={updateLoading}
                            >
                                {updateLoading ? 'Saving...' : 'Save'}
                            </button>
                            <button 
                                onClick={() => {
                                    setEditingContact(false);
                                    setError(null);
                                    // Reset form to original values
                                    setContactForm({
                                        company_name: vendorData?.Vendor[0].company_name || '',
                                        type_of_firm: vendorData?.Vendor[0].type_of_firm || '',
                                        gstin: vendorData?.Vendor[0].gstin || '',
                                        pan: vendorData?.Vendor[0].pan || '',
                                        association: vendorData?.Vendor[0].association || ''
                                    });
                                }}
                                className="bg-gray-300 text-gray-700 px-6 py-2 rounded-md text-sm font-medium"
                                disabled={updateLoading}
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Logout Button */}
            <div className="mx-4 mt-6 mb-24">
                <button 
                    onClick={handleLogout}
                    className="w-full bg-white rounded-lg p-4 shadow-sm flex items-center justify-center hover:bg-gray-50"
                    disabled={updateLoading}
                >
                    <FontAwesomeIcon icon={faSignOutAlt} className="text-red-500 mr-2" />
                    <span className="text-red-500 font-medium">Logout</span>
                </button>
            </div>

            {/* Loading Overlay */}
            {updateLoading && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 flex items-center">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-500 mr-3"></div>
                        <span className="text-gray-700">Updating profile...</span>
                    </div>
                </div>
            )}

      
{showImageModal && (
  <div
    className="fixed inset-0 flex items-start justify-center z-50 bg-black bg-opacity-30"
    onClick={() => setShowImageModal(false)}
  >
    <div
      className="relative bg-white rounded-xl w-[90vw] max-w-[400px] h-[40vh] mt-20 p-4 flex items-center justify-center"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Close Button */}
    <button
  onClick={() => setShowImageModal(false)}
  className="absolute top-3 right-3 bg-gray-200 rounded-full w-7 h-7 flex items-center justify-center shadow-md text-gray-700 z-50"
>
  <FontAwesomeIcon icon={faXmark} className="w-3 h-3" />
</button>


      {/* IMAGE DISPLAY */}
      {hasImage ? (
        <img
          src={selectedImage}
          alt="Vendor"
          className="max-w-full max-h-full object-contain"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-[#D9E0F6] rounded-lg">
          <span className="text-6xl font-bold text-[#1A73E7]">
            {getInitials(vendorData?.Vendor[0]?.name || userData?.customer_name)}
          </span>
        </div>
      )}
    </div>
  </div>
)}


            
        </div>
    );
}

export default ProfileAccount;

